import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import { DropDownArrow, customStyle } from '../../template/CustomStyle';
import { fetchAcciones } from '../../actions/usuariosActions';
import { toast } from 'react-toastify';
import { postAccionPredefinidaTipoUsuarioApi } from '../../api/axios';

function AccionPredefinidaNuevoWrapper(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <AccionPredefinidoNuevo {...props} navigate={navigate} location={location} />;
}

class AccionPredefinidoNuevo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            accionesOptions: [],
            selectedAccion: null,
        };
    }

    componentDidMount() {
        this.getAcciones();
    }

    getAcciones = async () => {
        try {
            this.setState({ loading: true });

            const response = await this.props.fetchAcciones(null);
            let items = response.data;

            const options = (Array.isArray(items) ? items : []).map(a => ({
                value: a.Id ?? a.id ?? null,
                label: a.Descripcion ?? a.descripcion ?? ''
            }));

            this.setState({
                accionesOptions: options,
                selectedAccion: null,
                loading: false
            });

        } catch (e) {
            console.error("Error obteniendo acciones:", e);
            this.setState({ loading: false });
        }
    };

    myChangeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    onSubmit = async (e) => {
        e.preventDefault();

        const { selectedAccion } = this.state;
        const idTipoUsuario = this.props.location?.state?.idTipoUsuario ?? null;
        const accionesActuales = this.props.location?.state?.accionesActuales ?? [];

        if (!selectedAccion) {
            toast.error("Seleccione una acción");
            return;
        }

        if (!idTipoUsuario) {
            toast.error("No se encontró el tipo de usuario seleccionado");
            return;
        }

        const existe = accionesActuales.some(a =>
            (a.accion.id) === selectedAccion.value
        );

        if (existe) {
            toast.error("Esta acción ya está asignada al tipo de usuario");
            return;
        }

        const request = {
            IdTipoUsuario: idTipoUsuario,
            IdAccion: selectedAccion.value
        };

        try {
            this.setState({ loading: true });

            const response = await postAccionPredefinidaTipoUsuarioApi(request);
            const respData = response.data ?? response;

            if (respData && respData.StatusCode === 404) {
                toast.error(respData.Message || "No se pudo crear la acción");
            } else {
                toast.success("Acción predefinida creada con éxito");
                this.return();
            }
        } catch (err) {
            console.error("Error al crear acción predefinida:", err);
            toast.error("Error al crear acción predefinida");
        } finally {
            this.setState({ loading: false });
        }
    };

    return = () => {
        this.props.navigate(-1);
    };

    handleChangeAccion = (selected) => {
        this.setState({ selectedAccion: selected });
    };

    render() {
        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">

                        <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                <div className='row align-items-center'>
                                    <div className="card-body p-b-5 d-flex align-items-center">
                                        <GoBackArrow />
                                        <h4 className="card-title ml-2">Nueva Acción Predefinida</h4>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-5">
                                    <label className="label-oscura">Acción</label>
                                    <Select
                                        name="tipoUsuario"
                                        options={this.state.accionesOptions}
                                        value={this.state.selectedAccion}
                                        onChange={this.handleChangeAccion}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                        styles={customStyle}
                                        placeholder="Seleccione una acción"
                                        isClearable
                                        noOptionsMessage={() => "No hay acciones disponibles"}
                                    />
                                </div>

                                <div className='d-flex justify-content-center'>
                                    {
                                        this.state.loading ? <MiniSpinner /> :
                                            <button
                                                type="submit"
                                                className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                                            >
                                                Guardar
                                            </button>
                                    }

                                    <button
                                        onClick={this.return}
                                        type="button"
                                        className="btn btn-sm btn-light waves-effect waves-light"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, {
    fetchAcciones,
})(AccionPredefinidaNuevoWrapper);